export default "__VITE_PUBLIC_ASSET__fceaa38e__"